import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { and } from '@angular/router/src/utils/collection';
import { menurolesService } from '../../services/menuroles.service';
import { EmployeeService } from '../../services/employee.service';
@Component({
  selector: 'app-role-accessibility',
  templateUrl: './role-accessibility.component.html',
  styleUrls: ['./role-accessibility.component.scss']
})
export class RoleAccessibilityComponent implements OnInit {

  public RoleSelectList: any[];
  public staffSelectList: any[];
  public selectedStaffid: number = -1;
  public selectedRoleid: number = -1;
  public menuList: any[];
  public isSlide: boolean = false;
  public mobileAccessbility = false;
  public menuListAll : any[];
  public menudata: any[];
  constructor(private router: Router, private fb: FormBuilder, private _analyticsService: AnalyticsService, private _menurolesService: menurolesService, private _employeeService: EmployeeService) { }

  ngOnInit() {
    //this.getAllRole();
    this.getStaffList();
  }


  // Get all Role and bind to dropdown list
  getAllRole() {
    this._menurolesService.getRole()
      .subscribe(
        (couponData) => {
          if (couponData.response == null) {
            this.RoleSelectList = [];
          }
          else {
            this.RoleSelectList = couponData.response.roleList;
            this.selectedRoleid = this.RoleSelectList[0].roleId
            this.getMenuListbyRole(this.selectedRoleid);
          }

        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }
  // Get all Staff list and bind to dropdown list
  getStaffList() {
    this._employeeService.getStaff()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.staffSelectList = [];
          }
          else {
            this.staffSelectList = employeeData.response.staffList
            this.selectedStaffid = employeeData.response.staffList[0].id
            this.getMenuListbyStaff(this.selectedStaffid);
          }

        },
        (error) => {
          console.log(error);
        }

      );
  }

  // Get all menus list based on to role id
  getMenuListbyRole(selectedRoleid) {
    this._menurolesService.getRoleUserMenus(this.selectedRoleid)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
          }
          else {
            this.menuList = employeeData.response.menuList
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  getMenuListbyStaff(selectedUserid) {
    this._menurolesService.getUserMenus(this.selectedStaffid)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
          }
          else {
            this.menuListAll = employeeData.response.menuList;
            if(this.mobileAccessbility){
              this.menuList = this.menuListAll.filter(menu=> menu.accessbilitydeviceid);
            }
            else{
              this.menuList = employeeData.response.menuList.filter(t => t.parentId);
            }
            this.menudata = this.menuList;
          }
        },
        (error) => {
          //this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }


  assignRoleMenu(userdata) {
    let confimationMessage = userdata.IsMenuAssign == true ? "Are you sure want to Unassigned " + userdata.menuName : "Are you sure want to Assigned " + userdata.menuName;
    if (confirm(confimationMessage)) {
      if (this.selectedRoleid) {
        this._menurolesService.assignRoleMenus(userdata, this.selectedRoleid).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Coupons records save Sucessfully")
              this.getMenuListbyRole(this.selectedRoleid);
            }
            else {
              alert(data.returnMsg)
            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Please select a coupon")
        return;
      }
    }
    else {
      console.log('else cancel');
      this.getAllRole();
    }

  }

  assignUserMenu(userdata) {
    let confimationMessage = userdata.IsMenuAssign == true ? "Are you sure want to Unassigned " + userdata.menuName : "Are you sure want to Assigned " + userdata.menuName;
    if (confirm(confimationMessage)) {
      if (this.selectedStaffid) {
        this._menurolesService.assignuserMenus(userdata, this.selectedStaffid).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("records save Sucessfully")
              this.getMenuListbyStaff(this.selectedStaffid);
            }
            else {
              alert(data.returnMsg)
            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Please select a coupon")
        return;
      }
    }
    else {
      // this.getStaffList();      
      this.getMenuListbyStaff(this.selectedStaffid)
    }

  }

  assignIsEditable(userdata) {
    if (userdata.IsMenuAssign == false) {
      alert("please Assign " + userdata.menuName + " for Staff")
      this.getMenuListbyStaff(this.selectedStaffid)
      return
    }
    else {
      let confimationMessage = userdata.IsMenuEditable == true ? "Are you sure want to make UnEditable  " + userdata.menuName : "Are you sure want to make Editable " + userdata.menuName;
      if (confirm(confimationMessage)) {
        this._menurolesService.assignEditableMenus(userdata, this.selectedStaffid).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("Record updated sucessfully")
              this.getMenuListbyStaff(this.selectedStaffid)
            }
            else {
              alert(data.returnMsg)

            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });

      }
      else {
        // this.getStaffList();
        this.getMenuListbyStaff(this.selectedStaffid)
      }
    }

  }

  selectedUserOption(id: number) {
    this.selectedStaffid = id
    this.getMenuListbyStaff(this.selectedStaffid)
  }

  selectOption(id: number) {
    this.selectedRoleid = id;
    this.getMenuListbyRole(this.selectedRoleid)
  }


  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }



  // method to showing the Mobile Accessbility List.
  showMobileAccessList(data: string){
    if(data == 'web' || data === 'web'){
      this.mobileAccessbility = false;
      this.getMenuListbyStaff(this.selectedStaffid);
    }
    else if(data == 'mobile' || data === 'mobile'){
      this.mobileAccessbility = true;
      this.menuList = this.menuListAll.filter(menu=> menu.accessbilitydeviceid);
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/admin/role-accessibility/role-accessibility.component.ts